<template>
    <div>
        <div class="help"><span class="label paid">Payée</span><span class="label not-paid">Non payée</span><span class="label unavailable">Indisponible</span></div>
        <div id="myCalendar" class="full-height"></div>
    </div>
</template>

<style lang="scss">
.calendar .calendar-container .event-container {
  border: 1px solid lightcoral;
}
.event-inner {
    padding: 10px !important;
}
.calendar .calendar-container .event-container .event-title {
    margin-bottom: 0;
    * {
    display: block;
    font-size: 13px;
    line-height: 17px;
    }
}
.bg-unavailable {
    background: #eaeaea;
}
.help {
    margin: 0 20px 20px 0;
}
.label {
    margin: 20px;
    &.paid {
        background: rgb(206, 255, 232);
    }
    &.not-paid {
        background: #fedde4;
    }
    &.unavailable {
        background: #eaeaea;
    }
}
</style>

<script type="text/babel">
export default {
  name: "Calendar",
  data() {
    return {
      eventArray: [],
      earlierOpeningTime: null,
      laterClosingTime: null
    }
  },
  props: ["filteredBookings", "filteredBookingsForWorkingHours"],
  mounted() {
    this.getEarlierOpeningTime()
    this.getLaterClosingTime()
    this.initCalendar(this.filteredBookings)
  },
  methods: {
    getEarlierOpeningTime() {
      _.forEach(this.filteredBookingsForWorkingHours, booking => {
        this.earlierOpeningTime = _.minBy(
            _.filter(booking.suborder.offer.distributed_product.agency.schedules, o => {
                if (!_.isNil(o.opening_time)) {
                    return o.opening_time
                }
          }), day => { return day.opening_time }
        )
        this.earlierOpeningTime = this.earlierOpeningTime.opening_time.slice(0,2)
      })
    },
    getLaterClosingTime() {
      _.forEach(this.filteredBookingsForWorkingHours, booking => {
        this.laterClosingTime = _.maxBy(
          _.filter(booking.suborder.offer.distributed_product.agency.schedules, o => {
            if (!_.isNil(o.closing_time)) {
              return o.closing_time
              }
          }), day => { return day.closing_time }
        )
        this.laterClosingTime = this.laterClosingTime.closing_time.slice(0, 2)
      })
    },
    initCalendar(newValue) {
      // if (typeof $('#myCalendar').pagescalendar('removeAllEvents') !== undefined) { $('#myCalendar').pagescalendar('removeAllEvents') }
      // INITIALISATION DU CALENDRIER
      var selectedEvent
      $("#myCalendar").pagescalendar({
        //OPTIONS
        ui: {
          year: {
            visible: true,
            format: "YYYY",
            startYear: moment("01/01/2016").format("YYYY"),
            endYear: moment()
              .add(2, "year")
              .format("YYYY"),
            eventBubble: true
          },
          month: {
            visible: true,
            format: "MMMM",
            eventBubble: true
          },
          date: {
            format: "dddd D MMMM YYYY"
          },
          week: {
            day: {
              format: "D"
            },
            header: {
              format: "dd"
            },
            eventBubble: true,
            startOfTheWeek: "0",
            endOfTheWeek: "6"
          },
          // Week view Grid Options
          grid: {
            // dateFormat: 'D dddd',
            timeFormat: "HH:00",
            eventBubble: true,
            // scrollToFirstEvent: false,
            // scrollToAnimationSpeed: 300,
            // scrollToGap: 20,
            slotDuration: "60"
          }
        },
        view: "week",
        now: moment().format(),
        locale: "fr",
        timeFormat: "HH:mm",
        minTime: 8, // this.earlierOpeningTime,
        maxTime: 19, // this.laterClosingTime,
        dateFormat: "dddd D MMMM YYYY",
        slotDuration: "60", //In Mins : only supports 30 and 60
        // eventOverlap: false,
        // weekends: true,
        // disableDates:[],
        events: [], // this.eventArray,
        onViewRenderComplete: function(event) {},
        onEventRender: function(event) {},
        onEventClick: function(event) {
          //Open Pages Custom Quick View
          if (!$("#calendar-event").hasClass("open"))
            $("#calendar-event").addClass("open")

          selectedEvent = event
          // setEventDetailsToForm(selectedEvent);
        },
        onEventDragComplete: function(event) {},
        onEventResizeComplete: function(event) {},
        onTimeSlotDblClick: function(timeSlot) {},
        onDateChange(range) {}
      })
      newValue.forEach(element => {
        let rangerWalker = moment().range(element.start_date, element.end_date)
        let color = ""

        if (_.has(element, 'suborder')) {
            switch (element.suborder.suborderable.payment_status) {
              case 'pending':
                color = "bg-success-lighter"
                break
              case 'paid':
                color = "bg-paid"
                break
            }

            let mobile_phone = element.suborder.suborderable.customer.main_representative && element.suborder.suborderable.customer.main_representative.mobile_phone ? '<span>' + element.suborder.suborderable.customer.main_representative.mobile_phone + '</span>' : ''
            let phone = element.suborder.suborderable.customer.main_representative && element.suborder.suborderable.customer.main_representative.phone ? '<span>' + element.suborder.suborderable.customer.main_representative.phone + '</span>' : ''
            // Teste si l'évènement s'étend sur plus d'une journée
            if (rangerWalker.diff("days") == 0) {
                this.eventArray.push({
                    allDay: true,
                    other: {},
                    title: '<a href="' + window.location.origin + '/customer/' + element.suborder.suborderable.customer.id + '" title="' + element.suborder.suborderable.customer.name.toString() + '">'
                        + element.suborder.suborderable.customer.name.toString()
                        + '</a>'
                        + mobile_phone.toString()
                        + phone.toString()
                        + '<span title="' + element.suborder.text.toString() + '">' + element.suborder.text.toString() + '</span>',
                    class: color,
                    start: element.start_date,
                    end: element.end_date,
                    readOnly: true
                })
            } else {
                for (let i = 0; i <= rangerWalker.diff("days"); i++) {
                    let day = moment(element.start_date).add(i, "days")
                    let weekday = day.weekday()
                    let start = null
                    let end = null
                    let event = {
                        allDay: false,
                        other: {},
                        title: element.suborder.text.toString(),
                        class: color,
                        readOnly: true
                    }

                    if (i == 0) {
                        start = day.hours(moment(element.start_date).hours())
                    } else {
                        start = !_.isNil(element.suborder.offer.distributed_product.agency.schedules[weekday].opening_time)
                        ? day.hours(element.suborder.offer.distributed_product.agency.schedules[weekday].opening_time.slice(0, 2))
                        : day
                    }
                    event.start = start.format()

                    if (i == 0 || i != rangerWalker.diff("days")) {
                        end = day.hours(element.suborder.offer.distributed_product.agency.schedules[weekday].closing_time.slice(0, 2))
                    } else {
                        end = moment(element.end_date)
                    }
                    event.end = end.format()

                    this.eventArray.push(event)
                }
            }
        } else {
            let reason = element.reason.toString()
            let name = element.global === true ? 'Tous les bureaux' : element.product_name
            if (rangerWalker.diff("days") == 0) {
                this.eventArray.push({
                    allDay: true,
                    other: {},
                    title: '<span title="' + reason + '">' + reason + '</span>'
                        + '<span title="' + name + '">' + name + '</span>',
                    class: 'bg-unavailable',
                    start: element.start_date,
                    end: element.end_date,
                    readOnly: true
                })
            } else {
                for (let i = 0; i <= rangerWalker.diff("days"); i++) {
                    let day = moment(element.start_date).add(i, "days")
                    let weekday = day.weekday()
                    let start = null
                    let end = null
                    let event = {
                        allDay: false,
                        other: {},
                        title: '<span title="' + reason + '">' + reason + '</span>'
                            + '<span title="' + name + '">' + name + '</span>',
                        class: 'bg-unavailable',
                        readOnly: true,
                        start: moment(day.hours(this.earlierOpeningTime))
                    }

                    if (i == 0 || i != rangerWalker.diff("days")) {
                        end = moment(day.hours(this.laterClosingTime))
                    } else {
                        end = moment(element.end_date)
                    }
                    event.end = end.format()

                    this.eventArray.push(event)
                }
            }
        }
      })
      $("#myCalendar").pagescalendar("addEvents", this.eventArray)
    }
  },
  watch: {
    filteredBookings(newValue, oldValue) {
        // console.log('fetchbookings has been updated !')
        $("#myCalendar").pagescalendar("removeAllEvents", this.eventArray)
        this.eventArray = []
        this.getEarlierOpeningTime()
        this.getLaterClosingTime()
        this.initCalendar(newValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/OneTimeLocations/Calendar.vue